var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"myFrom"}},[_c('div',{attrs:{"id":"title"}},[_vm._v("新增会员")]),_c('div',{attrs:{"id":"fromContent"}})])}]

export { render, staticRenderFns }